import React from 'react'
import { withTheme } from 'styled-components'
import { Flex, FlexColumn } from './Container'
import { Text } from './Text'
import hexToRgba from 'hex-to-rgba'

const StepHeader = (props) => {
    const { step, header, cta, theme } = props

    return (
        <Flex between centerH gap='8px'>
            <FlexColumn gap="0px">
                <Text color={hexToRgba(theme.colors.primary2, 0.6)} size='14px' >
                    {step}
                </Text>
                <Text size='30px' weight='600' height='40px'>
                    {header}
                </Text>
            </FlexColumn>
            {cta}
        </Flex>
        
    )
}

export default withTheme(StepHeader)